module.exports = __webpack_public_path__ + "img/dl-tag.50beb779.png";